import { render, staticRenderFns } from "./ContentAssist.vue?vue&type=template&id=87533eec&scoped=true&"
import script from "./ContentAssist.vue?vue&type=script&lang=js&"
export * from "./ContentAssist.vue?vue&type=script&lang=js&"
import style0 from "./ContentAssist.vue?vue&type=style&index=0&id=87533eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87533eec",
  null
  
)

export default component.exports